import { render, staticRenderFns } from "./CatalogDocumentList.vue?vue&type=template&id=780565b7&scoped=true&"
import script from "./CatalogDocumentList.vue?vue&type=script&lang=js&"
export * from "./CatalogDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDocumentList.vue?vue&type=style&index=0&id=780565b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780565b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VDataTable,VIcon,VTooltip})
